<template>
  <ElPopover :visible="popoverVisible" width="520px" placement="bottom-start">
    <template #reference>
      <ElInput readonly :value="currentCity" class="area-picker" @click="popoverVisible = !popoverVisible" clearable @clear="onClear">
        <template #suffix>
          <img :style="{ transition: 'all 0.2s', transform: popoverVisible ? 'rotate(0deg)' : 'rotate(180deg)' }"
            src="../../assets/area-picker-arrow.svg" />
        </template>
      </ElInput>
    </template>
    <!-- 地址组件 -->
    <PickerPanel @confirm="onConfirm" @cancel="onCancel" ref="pickerPanel" />
  </ElPopover>
</template>

<script setup lang="ts">
import { ElInput, ElPopover } from "element-plus"
import { createAreaContext } from "./context";
import { computed, ref, defineEmits, defineExpose } from "vue";
import PickerPanel from "./panel/area-picker-panel.vue";

const { model } = createAreaContext()
const emit = defineEmits(['confirm'])

const pickerPanel = ref();

const popoverVisible = ref(false)
const currentCity = ref('全国')

const inputValue = computed(() => {
  if (!model.city && !model.province) return '全国'

  return [model.province?.districtName, model.city?.districtName].filter(Boolean).join('/')
})

const onConfirm = () => {
  onCancel()
  console.log(inputValue.value, 'inputValue')
  currentCity.value = model.city?.districtName
  emit('confirm', currentCity.value)

}

const onCancel = () => {
  popoverVisible.value = false
}

const onClear = () => {
  currentCity.value = '全国'
}

const reset = () => {
  model.province = undefined;
  model.city = undefined
  pickerPanel.value?.reset()
  onClear()
}

defineExpose({ reset })
</script>

<style scoped>
.area-picker {
  width: 120px;
}
</style>